const SUPPORTED_UI_LANGS = [
  'en',
  'ar',
  'es',
  'fr',
  'de',
  'tr',
  'he',
  'zh',
  'ja',
  'ko',
  'pt',
  'ru',
  'it',
  'nl',
  'hi',
  'ur',
];

const EN = {
  commonCancel: 'Cancel',
  commonRefresh: 'Refresh',
  commonLoading: 'Loading...',
  commonSaving: 'Saving...',
  engagementClient: 'Client',
  engagementProject: 'Engagement',
  engagementClassification: 'Classification',
  engagementReportTemplate: 'Report Template',
  engagementYourLanguage: 'Your Language (chat in)',
  engagementClientLanguage: 'Client Language (deliverables)',
  engagementAnalystLanguage: 'Analyst Working Language',
  engagementLocale: 'Locale',
  engagementRegister: 'Register',
  engagementExportMode: 'Export Language Mode',
  engagementTranslateChat: 'Translate Chat',
  engagementTranslatingChat: 'Translating chat...',
  engagementSave: 'Save Engagement',
  engagementOtherLanguage: 'Other language...',
  engagementCustomLanguagePlaceholder: 'e.g. Welsh, Farsi, Ukrainian',
  engagementClientPlaceholder: 'Acme Corp',
  engagementProjectPlaceholder: 'Q1 Vishing Assessment',
  engagementCustomClassification: 'Custom marking (e.g. NATO RESTRICTED)',
  engagementHint:
    'Chat in Your Language - the consultant understands and replies in that language. Reports and exports use Client Language. Classification appears on exported PDF/DOCX/PPTX.',
  workspaceTitle: 'Workspace',
  workspaceShowAll: 'Show all',
  workspaceHideAll: 'Hide all',
  workspaceHint: 'Toggle panels on or off. The chat stays in the center; tools stay here.',
  workspaceEmpty:
    'Turn on a workspace panel above to configure the engagement, prompts, and pretexts.',
  promptLibraryTitle: 'Optional Prompt Library',
  promptLibraryHint:
    'Save optional session prompts you can apply on demand. Embedded tenant rules are always active server-side and are not listed here.',
  promptLibraryEmbeddedTitle: 'Active embedded rules',
  promptLibraryEmbeddedHint:
    'These tenant mandates are always applied to chat and reports. Operators cannot view the rule text.',
  promptLibraryEmbeddedActive: 'Always on',
  promptLibraryEmbeddedEmpty: 'No embedded rules configured for this tenant.',
  promptLibrarySelectLabel: 'Optional prompts',
  promptLibraryEmpty: 'No optional prompts saved yet',
  reportInstructionsLabel: 'Report instructions',
  reportInstructionsHint: 'One-off directives applied when you generate the report. Saved with this session.',
  reportInstructionsPlaceholder: 'e.g. Emphasize family-network vectors; omit financial analysis; add a dedicated OPSEC section…',
  promptLibraryApply: 'Apply to session',
  promptLibrarySaveTitle: 'Save to library',
  promptLibraryNamePlaceholder: 'Prompt name (e.g. Diplomatic attaché focus)',
  promptLibraryContentPlaceholder: 'Paste or type prompt text to save…',
  promptLibraryContentPlaceholderWithCurrent: 'Leave blank to save current mandates, or edit here…',
  promptLibraryUseCurrentMandates: 'Use current mandates',
  promptLibrarySaveButton: 'Save prompt',
  promptLibraryContentRequired: 'Enter mandate text in the box below or set operational mandates first.',
  promptLibraryApplied: 'Prompt applied to this session.',
  promptLibraryAppliedNamed: 'Applied "{{name}}" to this session.',
  promptLibraryAppliedClickSend: 'The prompt is in the chat box — click Send to generate (this may take several minutes).',
  promptLibraryAppliedToSession: 'Applied to this session',
  promptLibraryAppliedNationStateHint: 'Switch to Legend Sovereign mode for mandates to inject into chat.',
  promptLibrarySaved: 'Prompt saved to library.',
  promptLibraryUpdated: 'Prompt updated.',
  promptLibraryEditTitle: 'Edit saved mandate',
  promptLibraryUpdateButton: 'Save changes',
  promptLibraryNameRequired: 'Prompt name is required.',
  promptLibrarySelectToApply: 'Select Apply to load this mandate into the session. Prompt text is not shown.',
  promptLibraryReadOnlyHint: 'Read-only: choose a saved mandate by name and apply it. Prompt text is proprietary and hidden.',
  promptLibraryAppliedMandateLabel: 'Applied library mandate',
  promptLibrarySessionPromptLabel: 'Session prompt (ready to send)',
  promptLibrarySessionPromptHint: 'This text is loaded into the chat box below. Click Send to run it.',
  promptLibrarySendSessionPrompt: 'Send prompt',
  promptLibraryCategoryMandate: 'Operational mandate',
  promptLibraryCategoryChat: 'Chat prompt',
  promptLibraryCategoryReport: 'Report prompt',
  promptLibraryCategoryTradecraft: 'Tradecraft prompt',
  appErrorLoadPromptLibrary: 'Failed to load prompt library.',
  appErrorSavePromptLibrary: 'Failed to save prompt.',
  appErrorApplyPromptLibrary: 'Failed to apply prompt.',
  appErrorApplyPromptNoSession: 'No active session. Wait for the workspace to finish loading, then try again.',
  pdfPromptTitle: 'Password-protected PDF',
  pdfPromptEncrypted: '{{filename}} is encrypted.',
  pdfPromptBody: 'Enter the document password so the consultant can read and analyze it.',
  pdfPromptFileProgress: 'File {{current}} of {{total}}',
  pdfPromptInvalid: 'That password did not work. Please try again.',
  pdfPromptLabel: 'PDF password',
  pdfPromptPlaceholder: 'Enter PDF password',
  pdfPromptUnlock: 'Unlock PDF',
  pdfPromptUnlocking: 'Unlocking...',
  consentRecorded: 'Authorized-use consent recorded for Nation State Consultant mode.',
  consentTitle: 'Authorized Use Required',
  consentBody:
    'Nation State Consultant mode is intended only for authorized red-team planning, threat modeling, and defensive simulation. By continuing, you confirm you have proper authorization for this engagement.',
  consentPlaceholder: 'Your name or authorization reference',
  consentButton: 'I Confirm Authorized Use',
  kbTitle: 'Knowledge Base',
  kbAdminDesc: 'Shared knowledge used for consultant answers and reports.',
  kbOrgAdminDesc: 'Upload JSON, PDF, DOC, or DOCX files to add organization knowledge.',
  kbOperatorDesc: 'Upload target docs and notes, then sync to refresh the shared knowledge base index.',
  kbUserDesc: 'Shared platform knowledge base (read-only for your organization).',
  kbSyncNow: 'Sync Now',
  kbSyncing: 'Syncing...',
  kbSyncNowHint: 'Index new, changed, or removed visible files only. Use after uploads or visibility changes.',
  kbSyncNowDesc: ' — Scans stored files and updates the search index incrementally. Adds new visible files, re-embeds changed ones, and removes deleted ones. Does not wipe existing index data.',
  kbReindex: 'Reindex',
  kbReindexHint: 'Wipe and rebuild the entire search index from all visible files. Slower; use if results look wrong.',
  kbReindexDesc: ' — Deletes the full search index and rebuilds it from every visible file on disk. Slower than Sync Now; use when search results seem stale, missing, or corrupted.',
  kbSyncActionsTitle: 'Index actions',
  kbIndexed: 'Indexed',
  kbPending: 'Pending',
  kbChunks: 'Chunks',
  kbLastSync: 'Last Sync',
  kbNever: 'Never',
  kbStatusLoading: 'Loading knowledge base status...',
  kbIngestPlaceholder: 'Ingest URL (web page, RSS/podcast, or YouTube)',
  kbIngest: 'Ingest URL',
  kbIngesting: 'Ingesting...',
  kbUploadTitle: 'Add to Knowledge Base',
  kbUploadButton: 'Upload Files',
  kbUploading: 'Uploading...',
  kbUploadHint: 'PDF, DOCX, TXT, MD, XLSX, PPTX, CSV, HTML, and more',
  kbUploadHintAdmin: 'JSON, PDF, DOC, and DOCX only',
  kbUploadHintOperator: 'JSON, PDF, DOC, DOCX, and TXT',
  kbUploadSuccess: '{{count}} file(s) added and indexed',
  kbUploadSuccessNoindex: '{{count}} file(s) stored invisibly — mark visible and Sync Now to search',
  kbUploadSelectFiles: 'Select files to upload',
  kbUploadVisibleLabel: 'Make visible on upload',
  kbUploadVisibleHint: 'When unchecked (default), files are stored invisibly and excluded from search until marked visible and synced.',
  kbNoindexBadge: 'Invisible',
  kbVisible: 'Visible',
  kbInvisible: 'Invisible',
  kbMakeVisible: 'Make visible',
  kbMakeInvisible: 'Make invisible',
  kbShowPanel: 'KB',
  kbHidePanel: 'Hide KB',
  kbFilesTitle: 'Stored Files',
  kbFilesEmpty: 'No knowledge base files yet.',
  kbShowFiles: 'Show files',
  kbHideFiles: 'Hide files',
  kbDeleteFile: 'Delete',
  kbDeleting: 'Deleting…',
  kbDeleteConfirm: 'Delete {{name}} from the knowledge base? This cannot be undone.',
  kbFileStatusIndexed: 'Indexed',
  kbFileStatusPending: 'Pending',
  kbFileStatusNoindex: 'Stored only',
  kbFileStatusSkipped: 'Skipped',
  kbFileStatusError: 'Error',
  kbNoindexStat: 'Invisible',
  kbNoindexToggleOn: 'Make invisible',
  kbNoindexToggleOff: 'Make visible',
  kbNoindexUpdating: 'Updating…',
  kbIngestSectionTitle: 'Ingest URL',
  commonEdit: 'Edit',
  commonDelete: 'Delete',
  commonRemove: 'Remove',
  commonOptional: 'Optional',
  pretextStudioDescription: '9-section operational pretext builder for this engagement.',
  pretextStudioTitle: 'Pretext Studio',
  pretextSavedCount: '{{count}} saved',
  pretextExtracting: 'Extracting...',
  pretextExtractFromChat: 'Extract From Chat',
  pretextExtractHint: "Imports all scripts from chat; edit or delete any you don't need.",
  pretextExportCampaignPack: 'Export Campaign Pack',
  pretextNew: 'New Pretext',
  pretextNamePlaceholder: 'Pretext name',
  pretextTargetAudiencePlaceholder: 'Target audience',
  pretextTagsPlaceholder: 'Tags (comma separated)',
  pretextLegacyFields: 'Legacy fields (script / notes)',
  pretextLegacyScriptPlaceholder: 'Full script (legacy capture)',
  pretextAdditionalNotesPlaceholder: 'Additional notes',
  pretextUpdate: 'Update Pretext',
  pretextAdd: 'Add Pretext',
  pretextEmptyStateBeforeExtract:
    'No pretexts saved yet for this engagement. Pretexts developed in chat are not stored automatically - click',
  pretextEmptyStateMiddle: 'to import them into your library with all 9 sections, or click',
  pretextEmptyStateAfter: 'to build one manually.',
  pretextNoPersona: 'No persona',
  pretextSourceManual: 'manual',
  campaignDefaultName: 'Primary Campaign',
  campaignStudioTitle: 'Campaign Studio',
  campaignStudioDescription:
    'Sequence pretexts into a multi-step campaign with timeline, dependencies, and conditions.',
  campaignAddOrExtractFirst:
    'Add or extract pretexts first - campaign steps link to saved pretexts in your library.',
  campaignNamePlaceholder: 'Campaign name',
  campaignObjectivePlaceholder: 'Campaign objective',
  campaignReadyPretexts:
    'You have {{count}} pretext{{plural}} ready. Add steps manually to choose which pretext runs when - or auto-sequence all at once if you prefer.',
  campaignAddFirstStepManually: 'Add first step manually',
  campaignAutoSequenceAllPretexts: 'Auto-sequence all pretexts',
  campaignAddStep: 'Add step',
  campaignMoveEarlier: 'Move earlier',
  campaignMoveLater: 'Move later',
  campaignTimelineLabel: 'Timeline label',
  campaignPretextForStep: 'Pretext for this step',
  campaignSelectPretext: 'Select pretext...',
  campaignDependsOnOptional: 'Depends on (optional)',
  campaignNone: 'None',
  campaignConditionGate: 'Condition / gate',
  campaignConditionPlaceholder: 'e.g. Only if Step 1 yields partial compliance',
  campaignLinkedPretextRemoved: 'Linked pretext was removed - pick another from the list above.',
  campaignSave: 'Save Campaign',
  campaignTimelineTitle: 'Campaign timeline',
  campaignTimelineDescription: 'Each card is one step in order. Click a card to edit that step below.',
  campaignNoPretextSelected: 'No pretext selected',
  campaignAssignPretextHint: 'Assign a pretext in the step editor below.',
  campaignFailureIndicators: 'Failure indicators',
  campaignDependsOnLabel: 'Depends on:',
  campaignGateLabel: 'Gate:',
  campaignOrderLabel: 'Order',
  campaignNoScriptOrHookYet: 'No script or opening hook yet.',
  campaignNoPretextLinked: 'No pretext linked',
  campaignNoPreviewAvailable: 'No preview available',
  complianceDescription:
    'Lifecycle, ROE, authorization, multi-stakeholder review, and audit trail.',
  complianceTitle: 'Compliance & Review',
  complianceRefreshAudit: 'Refresh Audit',
  complianceLifecycle: 'Lifecycle',
  complianceDeliverableStatus: 'Deliverable Status',
  complianceLeadAnalystPlaceholder: 'Lead analyst (Author)',
  complianceAuthorizationReferencePlaceholder: 'Authorization reference / ticket',
  complianceExportBannerPlaceholder:
    'Export banner override (optional; classification preset used when empty)',
  complianceRulesOfEngagement: 'Rules of engagement',
  complianceExerciseWindowPlaceholder: 'Exercise window (dates/times)',
  complianceScopeBoundariesPlaceholder: 'Scope boundaries',
  complianceNoGoTargetsPlaceholder: 'No-go targets / systems',
  complianceEngagementGoalsPlaceholder: 'Engagement goals (steers mode outputs)',
  complianceRulesOfEngagementPlaceholder: 'Rules of engagement',
  complianceSave: 'Save Compliance',
  complianceSubmitForReview: 'Submit for Review',
  complianceApprove: 'Approve',
  complianceRelease: 'Release',
  complianceReviewerNamePlaceholder: 'Reviewer name',
  complianceApprovedByPlaceholder: 'Approved by (Approver)',
  complianceReviewNotesPlaceholder: 'Review notes',
  complianceApprovedAt: 'Approved at',
  complianceRecentAuditTrail: 'Recent Audit Trail',
  complianceNoAuditEvents: 'No audit events recorded for this engagement yet.',
  complianceActorLabel: 'Actor',
  complianceStatusLabel: 'Status',
  complianceFormatLabel: 'Format',
  complianceWorkflowPrefix: 'Workflow: draft -> in review -> approved -> released. Enable export gates with',
  complianceClassificationPreset: 'Classification preset',
  glossaryStep1Prefix: 'Step 1: Name terms in',
  glossaryStep1Middle: 'and choose whether each should translate to',
  glossaryStep2: 'Step 2: Generate client translations.',
  glossaryTitle: 'Translation Glossary',
  glossaryEmptyStatePrefix:
    'Add names, organizations, and phrases before translating deliverables. Example: lock',
  glossaryExampleLocked: 'Ali Sulyak',
  glossaryExampleTranslate: 'translate',
  glossaryExampleTranslationPair: 'pretext -> client term',
  glossaryTermLabel: 'Term ({{language}})',
  glossaryTermPlaceholder: 'e.g. pretext, Mehmet Kaya, aviation sector',
  glossaryClientTranslationLabel: 'Client translation ({{language}})',
  glossaryTranslationRule: 'Translation rule',
  glossaryTranslateToClient: 'Translate to client',
  glossaryKeepAsIs: 'Keep as-is',
  glossaryLockedPlaceholder: 'Locked - same in all languages',
  glossaryGenerateOrEditPlaceholder: 'Generate or edit manually',
  glossaryNotesPlaceholder: 'Notes (optional) - e.g. person name, org, technical term',
  glossaryAddTerm: 'Add term',
  glossaryAddLockedName: 'Add locked name',
  glossarySave: 'Save glossary',
  glossaryTranslating: 'Translating...',
  glossaryGenerateClientTranslations: 'Generate client translations ({{language}})',
  setupInvalidOrExpiredLink: 'This setup link is invalid or has expired.',
  setupMissingToken: 'Missing setup token.',
  setupUnableToComplete: 'Unable to complete setup',
  setupValidatingLink: 'Validating setup link...',
  setupAccountReadyTitle: 'Account ready',
  setupAccountReadyBody:
    'Your access key has been set. Sign in with your organization ID and the access key you just created.',
  setupGoToSignIn: 'Go to Sign In',
  setupSecureAccountTitle: 'Secure Account Setup',
  setupPrivateKeyForOrg: 'Set your private access key for {{organization}}.',
  setupPrivateKeyDefault: 'Set your private access key.',
  setupOrganizationId: 'Organization ID',
  setupChooseAccessKey: 'Choose Access Key',
  setupAccessKeyRequirements: 'At least 16 characters with letters and numbers.',
  setupConfirmAccessKey: 'Confirm Access Key',
  setupComplete: 'Complete Setup',
  signupUnableToSubmit: 'Unable to submit request',
  signupRequestReceivedTitle: 'Request received',
  signupRequestReceivedBody:
    'If your request is approved, we will email setup instructions to the address you provided.',
  signupBackToSignIn: 'Back to Sign In',
  signupRequestAccessTitle: 'Request Access',
  signupRequestAccessBody:
    'Tell us about your organization. Our team will review and provision your workspace.',
  signupCompanyName: 'Company Name',
  signupYourName: 'Your Name',
  signupWorkEmail: 'Work Email',
  signupUseCaseLabel: 'How will you use the platform?',
  signupSubmitting: 'Submitting...',
  signupSubmitRequest: 'Submit Request',
  reportReviewEmptyDash: '-',
  reportReviewOriginal: 'Original',
  reportReviewTranslation: 'Translation',
  reportReviewExecutiveSummary: 'Executive Summary',
  reportReviewExerciseExecutionRisk: 'Operational Execution Risk',
  reportReviewOverallRiskScoreLegacy: 'Overall Risk Score (legacy)',
  reportReviewReportSections: 'Report Sections ({{count}})',
  reportReviewBody: 'Body',
  reportReviewBullets: 'Bullets',
  reportReviewCitation: 'Citation',
  reportReviewSourceCitation: 'Source Citation',
  reportReviewPriorityRecommendations: 'Priority Recommendations',
  reportReviewIdentifiedVulnerabilities: 'Identified Vulnerabilities ({{count}})',
  reportReviewDescription: 'Description',
  reportReviewIncludeInReport: 'Include in report',
  reportReviewIncludeInReportHint:
    'Uncheck sections to exclude from review, export, and regeneration. Saved with this conversation.',
  reportReviewCompareHint:
    'Compare original and translation before accepting the deliverable. Use side-by-side review first, then switch to translation-only when satisfied.',
  reportReviewLeftLabel: 'Left',
  reportReviewRightLabel: 'Right',
  reportReviewPreparedFor: 'Prepared for',
  reportReviewPreparedBy: 'Prepared by',
  reportReviewGenerated: 'Generated',
  reportReviewTranslating: 'Translating...',
  reportReviewRunningQa: 'Running QA...',
  reportReviewTranslationQa: 'Translation QA',
  reportReviewPreparingDocx: 'Preparing DOCX...',
  reportReviewDownloadDocx: 'Download DOCX ({{language}})',
  reportReviewPreparingPdf: 'Preparing PDF...',
  reportReviewDownloadPdf: 'Download PDF ({{language}})',
  reportReviewPreparingDeck: 'Preparing deck...',
  reportReviewExportDeck: 'Export Deck (PPTX)',
  reportReviewPass: 'Pass',
  reportReviewRecommended: 'Review recommended',
  reportReviewNoIssuesFlagged: 'No issues flagged.',
  reportReviewRemoveFromReportAndLibrary: 'Remove from report & library',
  reportReviewRemoveFromPretextLibraryOnly: 'Remove from pretext library only',
  reportReviewRemoveFromReportAndLibraryHint1:
    'removes from the client deliverable, Pretext Studio, and campaign. Use',
  reportReviewRemoveFromReportAndLibraryHint2:
    'in Pretext Studio to drop a script from your library while keeping it in the report.',
  reportReviewRemoveConfirmPrompt:
    'Remove from report & library? Removes from the client report, Pretext Studio, and campaign.',
  reportReviewRemoveConfirmYes: 'Yes, remove everywhere',
  reportReviewExerciseExecutionRiskHint:
    'Operational risk to the government if proposed approaches are applied to the target (not a CVSS-style vulnerability score).',
  appDeliverableNotApprovedForRelease:
    'Deliverable is not approved for release. Report/campaign exports may be blocked when SEC_AI_REQUIRE_APPROVAL_FOR_EXPORT is enabled.',
  appToolsPanelHiddenPrefix: 'Tools panel hidden - click',
  appShowTools: 'Show Tools',
  appToolsPanelHiddenSuffix: 'for client and pretext controls.',
  appDismiss: 'Dismiss',
  loginInvalidCredentials: 'Invalid user name or password.',
  loginSignInFailed: 'Sign in failed. Check that the API is running on port 8000.',
  loginUnableToSignIn: 'Unable to sign in',
  loginSubtitle: 'Sign in to continue.',
  loginOrganizationId: 'User Name',
  loginAccessKey: 'Password',
  loginSigningIn: 'Signing in...',
  loginSignIn: 'Sign In',
  loginRequestOrganizationAccess: 'Request organization access',
  loginOrgAccessKey: 'Access key',
  loginUserAccount: 'User account',
  loginEmail: 'Email',
  loginPassword: 'Password',
  mfaEnrollInstructions: 'Scan this QR code with your authenticator app, then enter the 6-digit code to finish setup.',
  mfaVerifyInstructions: 'Enter the 6-digit code from your authenticator app.',
  mfaAuthenticatorCode: 'Authenticator code',
  mfaBackupCode: 'Backup code',
  mfaUseBackupCode: 'Use a backup code instead',
  mfaUseAuthenticator: 'Use authenticator app instead',
  mfaVerificationFailed: 'MFA verification failed. Check your code and try again.',
  mfaBackToSignIn: 'Back',
  mfaVerifying: 'Verifying...',
  mfaCompleteSetup: 'Complete MFA setup',
  mfaVerify: 'Verify',
  mfaManualSecret: 'Manual entry key',
  mfaQrAlt: 'MFA QR code',
  mfaBackupCodesInstructions: 'Save these backup codes in a secure place. Each code works once if you lose your authenticator.',
  mfaContinueToApp: 'Continue',
  followUpCancel: 'Cancel',
  citationsUnverifiedClaim:
    'No proprietary knowledge base or uploaded documents were retrieved for this reply. Validate critical claims against engagement context.',
  citationsUploadedDocuments: 'Uploaded engagement documents',
  citationsProprietaryCorpus: 'Proprietary intelligence corpus',
  citationsGroundedAssessment: 'Grounded assessment',
  citationsInternalSources: '{{count}} internal {{sourceLabel}}',
  citationsResponseInformedBy:
    'Response informed by {{internalLabel}}. Source titles and filenames are not shown to protect proprietary materials.',
  pretextNoContentYet: 'No content yet',
  campaignStepDefault: 'Step {{number}}',
  appErrorLoadAuditEvents: 'Failed to load audit events',
  appErrorLoadGlossary: 'Failed to load glossary',
  appErrorSaveGlossary: 'Failed to save glossary',
  appErrorTranslateGlossary: 'Failed to translate glossary to client language',
  appErrorSaveEngagement: 'Failed to save engagement',
  appErrorUpdateDeliverableReview: 'Failed to update deliverable review',
  appErrorLoadPretexts: 'Failed to load pretexts',
  appErrorLoadCampaign: 'Failed to load campaign',
  appErrorConsentNameRequired: 'Enter your name or authorization reference before continuing.',
  appErrorSessionInitializing: 'Session is still initializing. Please wait a moment and try again.',
  appErrorRecordConsent: 'Failed to record consent',
  appErrorCreatePretext: 'Failed to create pretext',
  appErrorUpdatePretext: 'Failed to update pretext',
  appErrorDeletePretext: 'Failed to delete pretext',
  appErrorClearPretextLibrary: 'Failed to clear pretext library',
  appErrorExtractPretexts: 'Failed to extract pretexts',
  appErrorSaveCampaign: 'Failed to save campaign',
  appErrorExportCampaignPack: 'Failed to export campaign pack',
  appErrorKbSyncFailed: 'Knowledge base sync failed',
  appConfirmKbReindex: 'Rebuild the entire knowledge base index?',
  appErrorKbReindexFailed: 'Knowledge base reindex failed',
  appErrorUrlIngestFailed: 'URL ingest failed',
  appErrorKbUploadFailed: 'Knowledge base file upload failed',
  appErrorLoadChatHistory: 'Failed to load chat history',
  appErrorSaveConversation: 'Failed to save conversation',
  appErrorLoadConversation: 'Failed to load conversation',
  appErrorOpenConversation: 'Failed to open conversation',
  appConfirmDeleteChat: 'Delete this chat from history?',
  appConfirmClearAllHistory: 'Delete all saved chat sessions? This cannot be undone.',
  appClearAllHistory: 'Delete all',
  appErrorDeleteConversation: 'Failed to delete conversation',
  appErrorGenerateReport: 'Failed to generate report',
  appErrorChooseLanguageBeforeTranslate: 'Choose a specific chat or report language before translating.',
  appErrorTranslateChat: 'Failed to translate chat',
  appErrorGenerateReportBeforeTranslate: 'Generate a report before translating.',
  appErrorChooseLanguageBeforeTranslateReport: 'Choose a specific report or chat language before translating.',
  appTranslationIncompleteWarning:
    'Translation may be incomplete. Review the side-by-side report before export.',
  appErrorTranslateReport: 'Failed to translate report',
  appErrorGenerateReportBeforeQa: 'Generate a report before running translation QA.',
  appErrorChooseLanguageBeforeQa:
    'Choose a specific report or chat language before running QA.',
  appErrorRunTranslationQa: 'Failed to run translation QA',
  appErrorSaveReportSectionPrefs: 'Failed to save report section preferences',
  appErrorGenerateReportBeforeDownload: 'Generate a report before downloading.',
  appErrorChooseLanguageBeforeBilingualExport:
    'Choose a specific report or chat language before side-by-side export.',
  appErrorUploadFiles: 'Failed to upload files',
  appErrorUploadFileTooLarge:
    'This file is too large for the server (limit 100 MB). Try a smaller PDF or split the document.',
  appErrorUploadForbidden:
    'Upload not allowed for your role or file type.',
  appErrorSubmitInquiry: 'Failed to submit inquiry',
  appErrorSaveReport: 'Failed to save report',
  appErrorCreateSession: 'Failed to create new session',
  appErrorUnlockPdf: 'Failed to unlock PDF',
  appErrorGetResponse: 'Failed to get response',
  appErrorDownloadReport: 'Failed to download {{format}} report',
  appErrorExportFormat: 'Failed to export {{format}}',
  appErrorSubmitServiceInquiry: 'Failed to submit service inquiry',
  appDeleteChatTitle: 'Delete chat',
  appUploadAnyFileTitle:
    'Upload documents, spreadsheets, images, audio, video, archives, and other files',
  appUploadAdminFileTitle: 'Upload JSON, PDF, DOC, or DOCX files',
  appUploadOperatorFileTitle: 'Upload JSON, PDF, DOC, DOCX, or TXT files',
  appStartConversationModeTitle: 'Start conversation mode',
  appStopSpeakingTitle: 'Stop speaking',
  appSelectVoiceTitle: 'Select voice',
};

const UI_TEXT = SUPPORTED_UI_LANGS.reduce((acc, code) => {
  acc[code] = { ...EN };
  return acc;
}, {});

function normalizeLanguage(languageCode) {
  const normalized = String(languageCode || 'en').trim().toLowerCase();
  if (!normalized || normalized === 'auto') return 'en';
  if (normalized.includes('-')) return normalized.split('-')[0];
  return normalized;
}

function interpolate(template, variables = {}) {
  return template.replace(/\{\{(\w+)\}\}/g, (_, key) => {
    return Object.prototype.hasOwnProperty.call(variables, key) ? String(variables[key]) : '';
  });
}

export function tUi(languageCode, key, variables = {}) {
  const lang = normalizeLanguage(languageCode);
  const template = UI_TEXT[lang]?.[key] ?? UI_TEXT.en[key] ?? key;
  return interpolate(template, variables);
}

export function getUiTextCatalog() {
  return UI_TEXT;
}

export function getUiTextKeys() {
  return Object.keys(UI_TEXT.en || {});
}

